import { MixpanelService } from '../../trackingAnalytics/services/mixPanel.service';
import { TrackEventParams } from '../types';

export const useTrackEvent = () => {
  return (params: TrackEventParams) => {
    if ('additionalContent' in params) {
      const { eventName, additionalContent = null } = params;
      MixpanelService.getInstance().storeEvent(eventName, additionalContent);
    } else {
      MixpanelService.getInstance().storeEvent(params.eventName);
    }
  };
};
